import { render, staticRenderFns } from "./SentEmailIcon.vue?vue&type=template&id=b478fc9a&"
import script from "./SentEmailIcon.vue?vue&type=script&lang=js&"
export * from "./SentEmailIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports